export const navItems = [
  {
    label: "Map of Brands",
    subtitle:
      "Find where your product category is sold worldwide in seconds. Uncover new markets and opportunities with TrendRocket.",
    value: "map_of_brands",
    path: "map-of-brands",
  },
  {
    label: "Map of Brands (V2)",
    subtitle:
      "Find where your product category is sold worldwide in seconds. Uncover new markets and opportunities with TrendRocket.",
    value: "map_of_brands_v2",
    path: "map-of-brands-v2",
  },
  {
    label: "Map of Brands (V3)",
    subtitle:
      "Find where your product category is sold worldwide in seconds. Uncover new markets and opportunities with TrendRocket.",
    value: "map_of_brands_v3",
    path: "map-of-brands-v3",
  },
  {
    label: "Check Competitor",
    subtitle:
      "Explore competitor’s website traffic and social stats, discover growth points, and amplify your discovery strategy.",
    value: "check_competitor",
    path: "comparison",
  },
  {
    label: "My Tracked Stores",
    subtitle: "Check out the stores tracked by you",
    value: "my_tracked_stores",
    path: "my-tracked-stores",
  },
];
